<template>
  <div class="project">
    <v-wait for="project-load">
      <template slot="waiting">
        <div class="vh-100 dt w-100 aspect-ratio--object grey">
          <div class="dtc v-mid tc white ph3 ph4-l">
            <h1 class="f6 f2-m f-subheadline-l fw6 tc green helvetica-ext">Loading</h1>
          </div>
        </div>
      </template>
      <div class="project-details pt6 pt6-m pt0-ns pt0-l">
        <div class="project-description dib mb4">
          <div class="fr w-100 w-two-thirds-ns w-two-thirds-l pt5 pt0-ns pt0-l">
            <div class="fl w-100 w-50-ns w-50-l">
              <div class="fl cf-ns cf-m w-100 w-60-ns w-60-l tl tr-ns tr-l mb3 mb0-ns mb0-l pr3"> <!-- CLIENT LOGO -->
                <img class="client-logo" :src="clientLogo">
              </div>
              <div class="fl cf-ns cf-m w-100 w-40-ns w-40-l green tl ph0 ph4-ns ph4-l mb3 mb0-ns mb0-l f3"> <!-- CAMPAIGN TYPE -->
                {{projectTitle}}<br>
                {{campaignName}}<br>
                {{campaignType}}
              </div>
            </div>
            <div class="fl cf-ns cf-m w-100 w-50-ns w-50-l">
              <div class="w-100 white helvetica-ext"> <!-- CAMPAIGN DESCRIPTION -->
                <p class="mb3 hyphenate lh-copy">
                  <span v-for="(desc, index) in projectDescription">{{desc}}<br></span>
                </p>
                <p class="mb3 hyphenate lh-copy">{{projectRole}}</p>
                <p class="mb3 hyphenate lh-copy">{{projectAgencyInfo}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="image-container tc"> <!-- CAMPAIGN IMAGERY -->
          <div  v-for="(image, index) in currentProjectImages"
                class="project-image dib mb4 w-100 cf pointer"
                :class="{ 'w-two-thirds-ns w-two-thirds-l fl-ns fl-l' : image.image_placement == 'Align Left',
                          'w-two-thirds-ns w-two-thirds-l fr-ns fr-l' : image.image_placement == 'Align Right',
                          'w-two-thirds-ns w-two-thirds-l'            : image.image_placement == 'Center',
                          'w-100-ns w-100-l'                          : image.image_placement == 'Full Bleed'
                        }">
            <img  v-if="image.is_video == false"
                  @click="loadProject(nextProject)"
                  :src="image.campaign_image.url.substring( 0, image.campaign_image.url.indexOf( '?auto=compress,format' ) )"
                  v-tippy="{
                    placement : 'bottom right',
                    arrow: false ,
                    content: 'next',
                    followCursor : true,
                    animation: 'false'}">
            <div class="video-wrapper" v-if="image.is_video == true && image.video_platform == 'YouTube'">
              <youtube :video-id="image.video_id" ref="youtube"></youtube>
            </div>
            <div class="video-wrapper" v-if="image.is_video == true && image.video_platform == 'Vimeo'">
              <vimeo-player
                ref="player"
                :video-id="image.video_id"
                :options="{ responsive: true, byline: false, portrait: false, title: false }"
                :player-height="320"
                :player-width="640"></vimeo-player>
            </div>
          </div>
        </div>
      </div>
    </v-wait>
  </div>
</template>

<script>
// @ is an alias to /src
import {_} from 'vue-underscore';

export default {
  name: 'project',
  components: {
    // Item
  },
  data() {
    return {
      allProjects: [],
      currentProject: {},
      currentProjectImages: [],
      clientLogo: '',
      projectTitle: '',
      campaignName: '',
      campaignType: '',
      projectDescription: [],
      projectRole: '',
      projectAgencyInfo: '',
      currentIndex: 0,
      prevProject: '',
      nextProject: ''
    }
  },
  methods: {
    hasHistory () { return window.history.length > 2 },
    goToProject(projectId) {
      this.$router.push({ name: 'project', params: { project_id: projectId } });
    },
    getImgUrl(img) {
      var images = require.context('../assets/', false, /\.(gif|jpe?g|tiff?|png|webp|bmp)$/);
      return images('./' + img)
    },
    clearCurrentProject(cb) {
      this.currentProject       = {};
      this.currentProjectImages = [];
      this.clientLogo           = '';
      this.projectTitle         = '';
      this.campaignName         = '';
      this.campaignType         = '';
      this.projectDescription   = [];
      this.projectRole          = '';
      this.projectAgencyInfo    = '';
      this.currentIndex         = 0;
      this.prevProject          = '';
      this.nextProject          = '';

      cb();
    },
    loadProject(project_uid) {
      var self = this;

      this.$wait.start('project-load');

      this.clearCurrentProject(function() {
        self.currentProject       = _.findWhere(self.allProjects, {uid: project_uid});
        self.currentIndex         = _.findIndex(self.allProjects, {uid: project_uid});

        self.currentProjectImages = self.currentProject.data.body[0].items;
        self.clientLogo           = self.currentProject.data.client_logo.url;
        self.projectTitle         = (self.currentProject.data.project_title[0].text != null) ? self.currentProject.data.project_title[0].text : '';
        self.campaignName         = (self.currentProject.data.campaign_name[0].text != null) ? self.currentProject.data.campaign_name[0].text : '';
        self.campaignType         = (self.currentProject.data.campaign_type[0].text != null) ? self.currentProject.data.campaign_type[0].text : '';
        self.projectRole          = (self.currentProject.data.role[0].text != null) ? self.currentProject.data.role[0].text : '';
        self.projectAgencyInfo    = (self.currentProject.data.agency_info[0].text != null) ? self.currentProject.data.agency_info[0].text : '';

        for (var paragraph_index in self.currentProject.data.project_description) {
          if (typeof self.currentProject.data.project_description[paragraph_index].text != undefined
              && self.currentProject.data.project_description[paragraph_index].text != null) {
            self.projectDescription.push(self.currentProject.data.project_description[paragraph_index].text);
          }
        }

        self.nextProject = (self.currentIndex >= self.allProjects.length - 1) ? self.allProjects[0].uid : self.allProjects[self.currentIndex + 1].uid;
        self.prevProject = (self.currentIndex <= 0) ? self.allProjects[self.allProjects.length - 1].uid : self.allProjects[self.currentIndex - 1].uid;

        window.scrollTo(0, 0, 'auto');

        self.$wait.end('project-load');
      });
    }
  },
  created() {
    var that = this;

    window.scrollTo(0, 0, 'auto');

    this.$wait.start('project-load');

    this.$store.dispatch('fetchProjects', { vm: this, cb:
      function(results) {
        that.allProjects = results;

        that.loadProject(that.$route.params.project_id);

        that.$wait.end('project-load');
      }
    });
  }
}
</script>
<style>
  html {
    scroll-behavior: auto;
  }

  .project {
  }

  .project-description {
    padding: 1rem 1.5rem 0;
  }

  .client-logo {
    max-width: 150px;
    width: 100%;
  }

  .project-image:last-child {
    margin-bottom: 0;
  }

  .video-wrapper {
    position: relative;
    padding-bottom: 56.25%; /* 16:9 */
    height: 0;
  }
  .video-wrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
</style>
